/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePointOfSaleToAreaV1Dto } from '../models/CreatePointOfSaleToAreaV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchPointOfSaleToAreaV1Dto } from '../models/PatchPointOfSaleToAreaV1Dto';
import type { PointOfSaleToAreaV1Dto } from '../models/PointOfSaleToAreaV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PointOfSaleToAreasService {
  /**
   * @param requestBody
   * @returns PointOfSaleToAreaV1Dto create entity
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1CreateV1(
    requestBody: CreatePointOfSaleToAreaV1Dto,
  ): CancelablePromise<PointOfSaleToAreaV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/point-of-sale-to-areas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns PointOfSaleToAreaV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1FindAllV1(): CancelablePromise<
    Array<PointOfSaleToAreaV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sale-to-areas',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/point-of-sale-to-areas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param posId pointOfSaleId
   * @returns PointOfSaleToAreaV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1FindManyByPointOfSaleIdV1(
    posId: string,
  ): CancelablePromise<Array<PointOfSaleToAreaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sale-to-areas/{posId}/areas',
      path: {
        posId: posId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param areaId areaId
   * @returns PointOfSaleToAreaV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1FindManyByAreaIdV1(
    areaId: string,
  ): CancelablePromise<Array<PointOfSaleToAreaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sale-to-areas/{areaId}/pointOfSales',
      path: {
        areaId: areaId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleToAreaId
   * @returns PointOfSaleToAreaV1Dto the entity
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<PointOfSaleToAreaV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sale-to-areas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleToAreaId
   * @param requestBody
   * @returns PointOfSaleToAreaV1Dto the update entity
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPointOfSaleToAreaV1Dto,
  ): CancelablePromise<PointOfSaleToAreaV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/point-of-sale-to-areas/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleToAreaId
   * @returns PointOfSaleToAreaV1Dto the entity
   * @throws ApiError
   */
  public static pointOfSaleToAreaControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<PointOfSaleToAreaV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/point-of-sale-to-areas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
